import React from "react";
import SelectionState from "state/selections/SelectionState";
import SummaryType from "state/selections/Constants/SummaryType";
import { titleCase } from "@ls/js-utils";
import {
  selectDefinitions,
  selectFetchingBookAnalyticsData,
} from "./selectors";
import { useDispatch, useSelector } from "react-redux";
import { deleteColumn } from "state/grid/actions";

const getDefaultColumnDef = (analytic) => {
  switch (analytic) {
    case "spread":
    case "LSpropOptionAdjustedSpread":
    case "liborSpread":
      return {
        X_decimal: 0,
        X_formatType: "NUMBER",
      };
    case "weight":
      return {
        X_decimal: 2,
        X_formatType: "PERCENTAGE",
      };
    default:
      return {};
  }
};

export const useColumnDefinitions = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingBookAbsData = useSelector(
    selectFetchingBookAnalyticsData(SummaryType.ABSOLUTE)
  );
  const fetchingBookRelData = useSelector(
    selectFetchingBookAnalyticsData(SummaryType.RELATIVE)
  );

  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.reduce((colDefs, BookAnalyticDefinition) => {
      const { bookAnalytic, summary, basis } = BookAnalyticDefinition;
      const colId = `${bookAnalytic},${basis},${summary}`;
      const colDef = {
        field: colId,
        colId: colId,
        headerName: `${titleCase(bookAnalytic)} ${titleCase(basis)} ${titleCase(summary === "ABSOLUTE" ? "" : summary)}`,
        loading:
          (summary === SummaryType.ABSOLUTE && fetchingBookAbsData) ||
          (summary === SummaryType.BENCHMARK && fetchingBookAbsData) ||
          (summary === SummaryType.RELATIVE && fetchingBookRelData),
        X_onDelete: () => dispatch(deleteColumn(BookAnalyticDefinition)),
        ...getDefaultColumnDef(bookAnalytic),
      };
      colDefs.push(colDef);
      return colDefs;
    }, []);
  }, [definitions, dispatch, fetchingBookAbsData, fetchingBookRelData]);
};
